import { render } from "./PricePercentSuggestor.vue?vue&type=template&id=9fb65eae"
import script from "./PricePercentSuggestor.vue?vue&type=script&lang=js"
export * from "./PricePercentSuggestor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__